import CryptoJS from 'crypto-js'
export default {
    aesEncrypt(text, KEY) {
        var iv=CryptoJS.enc.Utf8.parse('yunxuanpian2024a')
        var option={
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding:CryptoJS.pad.Pkcs7
        }
        KEY=KEY+"AB"
        KEY=CryptoJS.enc.Utf8.parse(KEY)

        var encrypted = CryptoJS.AES.encrypt(text, KEY, option);
        return encrypted.toString();
        var encrypted = CryptoJS.AES.encrypt(text, key);
        return encrypted.toString();
    },
    aesDecrypt(text, KEY) {
        var iv=CryptoJS.enc.Utf8.parse('yunxuanpian2024a')
        var option={
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding:CryptoJS.pad.Pkcs7
        }
        KEY=KEY+"AB"
        KEY=CryptoJS.enc.Utf8.parse(KEY)
        
        var decrypted = CryptoJS.AES.decrypt(text, KEY,option);
        return decrypted.toString(CryptoJS.enc.Utf8);

        var decrypted = CryptoJS.AES.decrypt(text, key);
        return decrypted.toString(CryptoJS.enc.Utf8);
    },
}